const Card = ({ icon, name, description, isRtl }) => {
    return (
        <div dir={isRtl ? 'rtl' : 'ltr'}>
            <div className='card mb-5 mx-3'>
                {icon && <img className='card-icon' src={icon} alt='Service icon' />}
                {name && <h4 className='card-title'>{name}</h4>}
                {description && <p className='card-subtitle text-center'>{description}</p>}
            </div>
        </div>
    );
};

export default Card;
